import { useEffect, useState } from "react";
import * as THREE from "three";

import { RegisterStatePositionObserver, RegisterStateObserver } from "Interfaces/StateInterface.js";

import "./style.css";

import TxtScreen4 from "Assets/txt_screen4.png";

export default function Screen4(){

    const [imageWidth, setImageWidth] = useState("100%");
    const [offsetX, setOffsetX] = useState("0px");
    const [offsetY, setOffsetY] = useState("0px");
    const [display, setDisplay] = useState("none");
    const [opacity, setOpacity] = useState(0);    

    const pointPosition = new THREE.Vector3(-1.35, 0.8, 23.5);

    function CalculatePosition(camera, proportion){        
        const screenPosition = pointPosition.clone();        
        screenPosition.project(camera);
        setOffsetX(((((1 + screenPosition.x) / 2) * window.innerWidth) - (187 * proportion)) + "px");
        setOffsetY(((((1 + -screenPosition.y) / 2) * window.innerHeight) - (187 * proportion)) + "px");
    }

    function ShowElement(){
        setDisplay("block");
        setTimeout(() => {
            setOpacity(1); 
        }, 1000);
    }

    function HideElement(){
        setOpacity(0);
        setTimeout(() => {
            setDisplay("none");
        }, 1500);
        
    }

    useEffect(() => {
        window.addEventListener('resize', () => {    
            setImageWidth((window.innerWidth * 0.7) + "px");
        });        
        setImageWidth((window.innerWidth * 0.7) + "px"); 
        
        RegisterStatePositionObserver("screen3", CalculatePosition);
        RegisterStatePositionObserver("screen4", CalculatePosition);
        RegisterStatePositionObserver("screen5", CalculatePosition);
        RegisterStateObserver("screen3", HideElement);
        RegisterStateObserver("screen4", ShowElement);
        RegisterStateObserver("screen5", HideElement);
    }, []);

    return (
        <div className="screen4" id="screen4" style={{ width: imageWidth, top: offsetY, left: offsetX, display: display, opacity: opacity }}  >
            <img alt="" src={TxtScreen4} />
        </div>
    )
}